import { useMemo, useState } from 'react';

import { Favorite } from '../../../Modules/Favorite';
import { useAppDispatch } from '../../../hooks/redux';
import { useCard } from '../../../hooks/useCard';
import { useFavorite } from '../../../hooks/useFavorite';
import { ICatalogItem } from '../../../shared/types/card';

export const useFavorites = () => {
  const dispatch = useAppDispatch();
  const { catalog_item } = useCard();
  const { favorites } = useFavorite();
  const isItemExistFavorite = Favorite.isItemExistFavorite(
    favorites,
    catalog_item.id
  );
  const [isSmashed, setIsSmashed] = useState(isItemExistFavorite);

  const onAddToFavorite = (card: ICatalogItem) => {
    Favorite.toggleFavorite(favorites, card, dispatch);
    setIsSmashed(!isItemExistFavorite);
  };

  return useMemo(
    () => ({
      actions: {
        onAddToFavorite,
      },
      favorite: { isSmashed },
    }),
    [isSmashed]
  );
};
